import { Skeleton } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { motion } from 'framer-motion';

type SkeletonMotionProps = {
    timeout?: number;
    randMul?: number;
    randOffset?: number;
} & React.ComponentProps<typeof Skeleton>;

const getRandomWidth = (
    randMul: number,
    randOffset: number
) => Math.random() * randMul + randOffset;

function SkeletonMotion({
    timeout = 1000,
    randMul = 60,
    randOffset = 30,
    ...props
}: SkeletonMotionProps) {
    const [width, setWidth] = useState(getRandomWidth(randMul, randOffset));

    useEffect(() => {
        const h = setInterval(() => setWidth(getRandomWidth(randMul, randOffset)), timeout);
        return () => clearInterval(h);
    }, []);

    const initialWidth = useMemo(() => getRandomWidth(randMul, randOffset), []);

    return (
        <motion.div
            initial={{ width: `${initialWidth}%` }}
            animate={{ width: `${width}%` }}
            transition={{
                type: 'spring',
                stiffness: 260,
                damping: 20,
            }}
        >
            <Skeleton {...props} />
        </motion.div>
    );
}

export { SkeletonMotion };
